export interface CircleEvent {
  id: string;
  title: string;
  description: string | null;
  venue: string;
  latitude: number | null;
  longitude: number | null;
  image_url: string | null;
  start_time: string;
  end_time: string;
  capacity: number;
  credit_cost: number;
  host_id: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  created_at: string;
  updated_at: string;
  approved_by: string | null;
  approved_at: string | null;
  cancelled_at: string | null;
  cancelled_reason: string | null;
  whatsapp_group: string | null;
  ticket_booking_url: string | null;
  host?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    avatar_url: string | null;
  };
}

export interface CircleBooking {
  id: string;
  circle_event_id: string;
  user_id: string;
  quantity: number;
  credits_spent: number;
  status: 'confirmed' | 'cancelled' | 'refunded';
  attendance_status: 'present' | 'no_show' | 'cancelled' | null;
  booked_at: string;
  cancelled_at: string | null;
  marked_by: string | null;
  marked_at: string | null;
  user?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    avatar_url: string | null;
  };
}

export interface CircleBan {
  id: string;
  user_id: string;
  banned_at: string;
  banned_by: string | null;
  reason: string | null;
  auto_ban: boolean;
  unbanned_at: string | null;
  unbanned_by: string | null;
  no_show_count: number;
  user?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    avatar_url: string | null;
  };
}

export interface CircleConfig {
  enabled: boolean;
  credit_cost: number;
  required_tags: string[];
  auto_ban_threshold: number;
  auto_ban_enabled: boolean;
  cancellation_window_hours: number;
  attendance_window_hours: number;
}

export const DEFAULT_CIRCLE_CONFIG: CircleConfig = {
  enabled: true,
  credit_cost: 1,
  required_tags: [],
  auto_ban_threshold: 2,
  auto_ban_enabled: true,
  cancellation_window_hours: 24,
  attendance_window_hours: 1,
};

export interface CircleApplication {
  id: string;
  user_id: string;
  status: 'pending' | 'approved' | 'rejected';
  message: string | null;
  created_at: string;
  reviewed_by: string | null;
  reviewed_at: string | null;
  rejection_reason: string | null;
  user?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    avatar_url: string | null;
  };
}
